export var DurationUnitEnum;
(function (DurationUnitEnum) {
    DurationUnitEnum["ROUND"] = "Round";
    DurationUnitEnum["MINUTE"] = "Minute";
    DurationUnitEnum["HOUR"] = "Hour";
    DurationUnitEnum["DAY"] = "Day";
    DurationUnitEnum["UNTIL_DISPELLED"] = "Until Dispelled";
    DurationUnitEnum["SPECIAL"] = "Special";
})(DurationUnitEnum || (DurationUnitEnum = {}));
